import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFound(): JSX.Element {
  return (
    <div className="mx-auto max-w-md space-y-4 py-16 text-center">
      <h1 className="text-3xl font-semibold tracking-tight">Page introuvable</h1>
      <p className="text-sm text-slate-600">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Button asChild>
        <Link to="/app">Retour au tableau de bord</Link>
      </Button>
    </div>
  );
}
